module.exports = __webpack_public_path__ + "img/impactoI2.aed322a5.png";